export default "__VITE_ASSET__BqjFHBRt__"